/**
 * Upper case the first character of an input string.
 */
export function upperCaseFirst(input) {
    return input.charAt(0).toUpperCase() + input.substr(1);
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/capital-case/node_modules/upper-case-first/dist.es2015/index.js
// module id = 846
// module chunks = 1